import {message, Modal} from 'antd';
import {AccountFieldsFragment, useCalculateRiskScoreMutation} from 'api/generated';
import {Formik} from 'formik';
import {Form, FormItem, Select} from 'formik-antd';
import React from 'react';
import * as yup from 'yup';
import {useIgnoredKeywords} from '../../hooks/useIgnoredKeywords';

type Props = {
  account?: AccountFieldsFragment | null;
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
};

const validationSchema = yup.object().shape({
  riskIgnoredKeywords: yup.array().of(yup.string())
});

export const CalculateRiskAssessmentModal: React.FC<Props> = ({account, isOpen, setIsOpen}) => {
  const [calculateRiskScore] = useCalculateRiskScoreMutation();
  const {keywordsOptions} = useIgnoredKeywords(account!);

  if (!account) return null;

  const initialValues = {
    riskIgnoredKeywords: account?.riskIgnoredKeywords || []
  };

  const handleSubmit = async ({riskIgnoredKeywords}: typeof initialValues) => {
    await calculateRiskScore({
      variables: {
        input: {accountId: account.id, ignoredKeywords: riskIgnoredKeywords}
      }
    });
    message.success('The request usually takes less than 5 minutes to process.');
    setIsOpen(false);
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize>
        {({submitForm, isSubmitting, resetForm}) => (
          <Modal
            title="Are you sure?"
            okText="Calculate risk score"
            okType="primary"
            open={isOpen}
            confirmLoading={isSubmitting}
            onOk={submitForm}
            width={640}
            afterClose={resetForm}
            onCancel={() => {
              setIsOpen(false);
            }}>
            <Form layout="vertical">
              <p>
                This will calculate risk score for the account. It will take a few minutes to
                process.
              </p>
              <FormItem name="riskIgnoredKeywords" label="Ignored keywords">
                <Select
                  name="riskIgnoredKeywords"
                  mode="multiple"
                  allowClear
                  placeholder="Select keywords"
                  style={{width: '100%'}}
                  options={keywordsOptions}></Select>
              </FormItem>
            </Form>
          </Modal>
        )}
      </Formik>
    </>
  );
};
